












import { Component, Vue } from "vue-property-decorator";
import StInput2 from "@/components/basic/StInput2.vue";
import TimeEntryFilterComponent from "@/components/timeentry-filter/TimeEntryFilterComponent.vue";
import TimeEntryGrouper from "@/components/timeentry-filter/TimeEntryGrouper.vue";
import SlideIn from "@/components/basic/SlideIn.vue";
import ListTable from "@/views/List/ListTable.vue";
import ListColumnEdit from "@/views/List/ListColumnEdit.vue";

Component.registerHooks(["beforeRouteUpdate"]);

@Component({
  components: { SlideIn, TimeEntryGrouper, TimeEntryFilterComponent, StInput2, ListTable, ListColumnEdit }
})
export default class TemporaryPassword extends Vue {
}
